import styled from "styled-components"
import logo from '../assets/logo3x.png'

const HeaderPlato = styled.div`
  background-image: url(${logo});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 6.5rem auto;
  color: white;
  min-height: 8.5rem;
  padding: 0 50%;
`

export default HeaderPlato